import RsaGestioneAmbulatoriale from "../";

const routes = [
    {
        name: "RsaGestioneAmbulatorialeListPage",
        path: "/rsagestioneambulatoriale",
        component: RsaGestioneAmbulatoriale.RsaGestioneAmbulatorialeListPage,
        meta: { title: " Gestione Ambulatoriale" },
    },
];

export default routes;
